import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { SectionGate } from "@/features/explore";
import { Sidebar } from "./Sidebar";
import { BottomTabs } from "./BottomTabs";
import { MobileTopBar } from "./MobileTopBar";

/** App-shell: sidebar (desktop) + bottom tabs (mobile). Portal layout. */
export function Layout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      <MobileTopBar />

      <main className={collapsed ? "md:pl-16" : "md:pl-60"}>
        <div className="mx-auto max-w-5xl px-4 py-6 pb-24 md:pb-10">
          <Outlet />
        </div>
      </main>

      <BottomTabs />
      <SectionGate />
      <Toaster richColors />
    </div>
  );
}

export default Layout;
